@if (!loadComplete()) {
  <is-wait-message [useBolt]="false" [loadComplete]="loadComplete()" [timeoutAmount]="0"></is-wait-message>
}

@if (paymentFormReview && loadComplete()) {
  <form class="fluid-container" #paymentForm="ngForm" (ngSubmit)="onSubmit()" [formGroup]="paymentFormReview.group" class="manage-payment-form-container">
    <div class="bolt-container">
      <bolt-progress-bar appFocusOnInit arialabel="setup automatic payments progress value is 75%" class="progress-bar-container to-container" value="75"></bolt-progress-bar>
      <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Set up automatic
      payments: review & submit</h1>
      <div class="bolt-row">
        <div class="bolt-col-12">
          <section id="payment-details">
            <app-payment-sub-header>Payment details</app-payment-sub-header>
            <fieldset class="section-content">
              <legend class="fields-only"></legend>
              @for (field of paymentDetailsReviewFields; track field) {
                @if (!field.cardType) {
                  <app-recap-form-field [field]="field" class="bolt-space-bottom-xl">
                  </app-recap-form-field>
                }
                @if (field.cardType) {
                  <app-bankcard-recap-form-field [field]="field" class="bolt-space-bottom-xl">
                  </app-bankcard-recap-form-field>
                }
              }
            </fieldset>
          </section>
          @if (considerThisSectionDisplayable) {
<section [ngClass]="{'bolt-space-bottom-lg':
					this.review.enrollingInEzPay === 'Yes'}">
              <fieldset class="section-content">
                <legend class="fields-only"></legend>
                @for (field of considerThisReviewFields; track field) {
                  <app-recap-form-field id="consider-this-fieldset" class="bolt-space-bottom-xl" [field]="field">
                  </app-recap-form-field>
                }
              </fieldset>
            </section>
          }
          @if (emailAddress) {
            <section>
              <app-payment-sub-header>
                Contact information
              </app-payment-sub-header>
              <app-email-form-control formGroupName="emailAddressGroup">
              </app-email-form-control>
            </section>
          }
          <section id="auto-pay-authorization-section" class="bolt-space-bottom-2xl">
            <app-payment-sub-header>Authorization agreement</app-payment-sub-header>
            @if (canShowWaitSpinner()) {
              <bolt-waiting-indicator class="bolt-space-bottom-lg"></bolt-waiting-indicator>
            }
            @if (canDisplayAuthorizationAgreement) {
              <div>
                <span>Check that you've read and agree to the terms of the agreement.</span>
                <div class="ez-pay-section-content">
                  <app-ez-pay-authorization formGroupName="ezPayAuthGroup"></app-ez-pay-authorization>
                </div>
              </div>
            }
            @if (!canDisplayAuthorizationAgreement && generateAutoPayAuthorizationErrorContent) {
              <div>
                <bolt-notification id="generate-auto-pay-authorization-error" class="to-container bolt-space-bottom-2xl" type="error">
                  <is-interpolate [text]="generateAutoPayAuthorizationErrorContent"></is-interpolate>
                </bolt-notification>
              </div>
            }
          </section>
        </div>
      </div>
    </div>
    <bolt-button-bar>
      <is-button slot="cancel" id="cancel-button" (click)="navigateToPaymentPreferences()">Cancel</is-button>
      <is-button slot="back" id="back-button" (click)="navigateToSetupAutomaticPayments()">Back</is-button>
      <is-button [isDisabled]="disableSubmit() || canShowWaitSpinner()" id="submit-button" slot="forward" (click)="paymentForm.onSubmit($event)" [type]="solid" class="jm-visible" [class]="'jm-visible'">Submit</is-button>
    </bolt-button-bar>
  </form>
}